import store from '@/store';

function regexFiscalCode(lengths: number | number[], value: string): boolean {
    const stringValidation = '[a-zA-Z0-9_.-]';
    const validationRules = [];

    if (typeof lengths === 'number') {
        validationRules.push(`${stringValidation}{${lengths}}`);
    } else {
        lengths.forEach((length) => {
            validationRules.push(`${stringValidation}{${length}}`);
        });
    }

    const regexp = new RegExp(`^(${validationRules.join('|')})$`);
    return regexp.test(value);
}

function validateFiscalCodeIt(value: string): boolean {
    return regexFiscalCode([11, 13, 16], value);
}

function validateFiscalCodeEs(value: string): boolean {
    return regexFiscalCode(9, value);
}

function validateFiscalCodeDe(value: string): boolean {
    return regexFiscalCode(11, value);
}

function validateFiscalCodeFr(value: string): boolean {
    return regexFiscalCode(13, value);
}

export default function validateFiscalCode(value: string): boolean {
    switch (store.state.options.store_code) {
        case 'it_it':
            return validateFiscalCodeIt(value);

        case 'es_es':
            return validateFiscalCodeEs(value);

        case 'de_de':
            return validateFiscalCodeDe(value);

        case 'fr_fr':
            return validateFiscalCodeFr(value);

        default:
            return false;
    }
}
